import { render, staticRenderFns } from "./ViewKeyword.vue?vue&type=template&id=c7f512e0&scoped=true&"
import script from "./ViewKeyword.vue?vue&type=script&lang=js&"
export * from "./ViewKeyword.vue?vue&type=script&lang=js&"
import style0 from "./ViewKeyword.vue?vue&type=style&index=0&id=c7f512e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f512e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
